import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Ex = makeShortcode("Ex");
const Translation = makeShortcode("Translation");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`闘牛士の歌 （カルメン）`}</h1>
    <div style={{
      padding: 16,
      margin: 8,
      border: '1px solid orange'
    }}>
  こちらのコンテンツは新しいサイトに移行しています。以下のリンクから新サイトをご覧ください。
  <div style={{
        margin: 16,
        textAlign: "center",
        overflowWrap: "break-word"
      }}>
    <a href="https://capriccioso.info/opera/carmen/toreador">https://capriccioso.info/opera/carmen/toreador</a>
  </div>
    </div>
    <h4>{`Votre toast, je peux vouz le rendre`}</h4>
    <p>{`前奏曲にも現れる有名なメロディ。闘牛士エスカミーリョによる、低音の迫力満点なかっこいい曲です。`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Bizet: Carmen-Toreador song - Laurent Naouri`}</h4>
    <iframe width="100%" height="315" maxWidth="560" src="https://www.youtube.com/embed/e5qmSEvDEGs" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Bizet-Carmen-Toreador (El Torero Escamillo) SUBTITULOS en ESPAÑOL`}</h4>
    <iframe width="100%" height="315" maxWidth="560" src="https://www.youtube.com/embed/CoV2YOjFowY" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Bizet-Carmen-Toreador (El Torero Escamillo) SUBTITULOS en ESPAÑOL`}</h4>
    <iframe width="100%" height="315" maxWidth="560" src="https://www.youtube.com/embed/RNPjH01PtZ4" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <p>
  <Ex m="あなたの、あなたがたの" mdxType="Ex">Votre</Ex> <Ex m="乾杯" mdxType="Ex">toast</Ex>,{" "}
  <Ex m="私は" mdxType="Ex">je</Ex>{" "}
  <Ex m="できる" o="pouvoir" mdxType="Ex">
    peux
  </Ex>{" "}
  <Ex m="あなたに、あなたがたに" mdxType="Ex">vous</Ex>{" "}
  <Ex m="それを = votre toast （あなたがたの乾杯）" mdxType="Ex">le</Ex>{" "}
  <Ex m="返す" mdxType="Ex">rendre</Ex>,
    </p>
    <Translation mdxType="Translation">あなたがたの乾杯にお返しをさせてください。</Translation>
    <p>
  <Ex m="みなさん（スペイン語。フランス語のmessieursにあたる）" mdxType="Ex">Señors</Ex>,
  señors, <Ex m="なぜなら" mdxType="Ex">car</Ex> <Ex m="〜とともに" mdxType="Ex">avec</Ex>{" "}
  <Ex m="兵隊（複数）" mdxType="Ex">les soldats</Ex>
    </p>
    <Translation mdxType="Translation">みなさん、なぜって兵隊さんたちとは、</Translation>
    <p>
  <Ex m="はい" mdxType="Ex">Oui</Ex>, <Ex m="闘牛士（複数）（スペイン語）" mdxType="Ex">les Toreros</Ex>{" "}
  <Ex m="できる" o="pouvoir" mdxType="Ex">
    peuvent
  </Ex>{" "}
  <Ex m="理解し合う" mdxType="Ex">s'entendre</Ex>,
    </p>
    <Translation mdxType="Translation">ええ、われわれ闘牛士は仲良くなれるのだから。</Translation>
    <Ex m="〜のために" mdxType="Ex">Pour</Ex>{" "}
    <Ex m="喜び" mdxType="Ex">plaisirs</Ex>, pour plaisirs,{" "}
    <Ex m="彼ら = 兵隊と闘牛士たち" mdxType="Ex">ils</Ex>{" "}
    <Ex m="持っている" o="avoir" mdxType="Ex">
  ont
    </Ex>{" "}
    <Ex m="戦い（複数）" mdxType="Ex">les combats</Ex> !
    <Translation mdxType="Translation">どちらも喜びのために戦うのだ！</Translation>
    <p>
  <Ex m="サーカス、競技場（ここでは闘牛場）" mdxType="Ex">Le cirque</Ex>{" "}
  <Ex m="〜である（英語のbe動詞）" o="être" mdxType="Ex">
    est
  </Ex>{" "}
  <Ex m="いっぱいの" mdxType="Ex">plein</Ex>,{" "}
  <Ex m="ce + est の縮約。ceは「これ、それ」estは「〜である」（英語のbe動詞）" mdxType="Ex">
    c'est
  </Ex>{" "}
  <Ex m="日" mdxType="Ex">jour</Ex> <Ex m="〜の" mdxType="Ex">de</Ex> <Ex m="祝祭" mdxType="Ex">fête</Ex> !
    </p>
    <Translation mdxType="Translation">闘牛場は満員だ、今日はお祭りの日！</Translation>
    <p>
  Le cirque est plein{" "}
  <Ex m="上から下まで（haut=高いところ、bas=低いところ）" mdxType="Ex">du haut en bas</Ex>,
    </p>
    <Translation mdxType="Translation">闘牛場は満員だ、上から下まで。</Translation>
    <p>
  <Ex m="観客（複数）" mdxType="Ex">Les spectateurs</Ex>,{" "}
  <Ex m="失う" o="perdre" mdxType="Ex">
    perdant
  </Ex>{" "}
  <Ex m="頭" mdxType="Ex">la tête</Ex>,
    </p>
    <Translation mdxType="Translation">観客たちは、われを忘れて、</Translation>
    <p>
  Les spectateurs{" "}
  <Ex m="声を掛け合う" o="s'interpeller" mdxType="Ex">
    s'interpellent
  </Ex>{" "}
  <Ex m="大音響を立てて" mdxType="Ex">à grand fracas</Ex> !
    </p>
    <Translation mdxType="Translation">観客たちは、声を掛け合い大騒ぎ！</Translation>
    <p>
  <Ex m="乱暴な呼びかけ（複数）" mdxType="Ex">Apostrophes</Ex>,{" "}
  <Ex m="叫び声（複数）" mdxType="Ex">cris</Ex> <Ex m="〜と、そして（英語のand）" mdxType="Ex">et</Ex>{" "}
  <Ex m="騒ぎ、騒音" mdxType="Ex">tapage</Ex>
    </p>
    <Translation mdxType="Translation">掛け声、叫び声、大騒動</Translation>
    <p>
  <Ex m="pousser（押す、ある状態に至らせる）の過去分詞" o="pousser" mdxType="Ex">
    Poussés
  </Ex>{" "}
  <Ex m="〜まで（現代フランス語ではjusqu'à）" mdxType="Ex">jusques à</Ex>{" "}
  <Ex m="激怒、熱狂" mdxType="Ex">la fureur</Ex> !
    </p>
    <Translation mdxType="Translation">ついには興奮のるつぼにいたる</Translation>
    <p>
  <Ex m="なぜなら" mdxType="Ex">Car</Ex>{" "}
  <Ex m="ce + est の縮約。ceは「これ、それ」estは「〜である」（英語のbe動詞）" mdxType="Ex">
    c'est
  </Ex>{" "}
  <Ex m="祝祭" mdxType="Ex">la fête</Ex> <Ex m="de (〜の) + le (定冠詞)" mdxType="Ex">du</Ex>{" "}
  <Ex m="勇気" mdxType="Ex">courage</Ex> !
    </p>
    <Translation mdxType="Translation">今日は武勇のお祭りだから</Translation>
    <p>
  C'est la fête <Ex m="de (〜の) + les (定冠詞 複数)" mdxType="Ex">des</Ex>{" "}
  <Ex m="人々" mdxType="Ex">gens</Ex> <Ex m="〜の" mdxType="Ex">de</Ex> <Ex m="心臓、勇気" mdxType="Ex">cœur</Ex> !
    </p>
    <Translation mdxType="Translation">勇気ある人々のお祭りだから</Translation>
    <p>
  <Ex m="さあ（掛け声）" o="aller" mdxType="Ex">
    Allons
  </Ex>{" "}
  ! <Ex m="構えろ" mdxType="Ex">en garde</Ex> ! allons ! allons ! ah !
    </p>
    <Translation mdxType="Translation">さあ！ 構えろ！ さあ！ さあ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="闘牛士" mdxType="Ex">Toréador</Ex>, en garde ! Toréador ! Toréador !
    </p>
    <Translation mdxType="Translation">
  トレアドール、構えはいいか！ トレアドール！ トレアドール！
    </Translation>
    <p>
  <Ex m="そして（英語のand）" mdxType="Ex">Et</Ex>{" "}
  <Ex m="考える、想像する" o="songer" mdxType="Ex">
    songe
  </Ex>{" "}
  <Ex m="よく" mdxType="Ex">bien</Ex>, <Ex m="はい（英語のyes、ここでは強調）" mdxType="Ex">oui</Ex>,
  songe{" "}
  <Ex m="戦いながら" o="combattre" mdxType="Ex">
    en combattant
  </Ex>
  ,
    </p>
    <Translation mdxType="Translation">そして忘れるな、そう、戦いながらも忘れるな</Translation>
    <p>
  <Ex m="〜であること（英語のthat）ここではsongerの目的語" o="que" mdxType="Ex">
    Qu'
  </Ex>
  <Ex m="目" mdxType="Ex">un œuil</Ex> <Ex m="黒い" mdxType="Ex">noir</Ex> <Ex m="君を" mdxType="Ex">te</Ex> <Ex m="見る" o="regarder" mdxType="Ex">
    regarde
  </Ex>
    </p>
    <Translation mdxType="Translation">黒い瞳が君を見つめていることを</Translation>
    <p>
  Et <Ex m="〜であること（Qu'un œuilのqu'と並列になっている）" mdxType="Ex">que</Ex>{" "}
  <Ex m="愛、恋" mdxType="Ex">l'amour</Ex>{" "}
  <Ex m="te (君を) + attend (待つ)" o="attendre" mdxType="Ex">
    t'attend
  </Ex>
  , Toréador,
    </p>
    <Translation mdxType="Translation">そして恋が君を待っていることを。トレアドール</Translation>
    <p>L'amour, l'amour t'attend !</p>
    <Translation mdxType="Translation">恋が、恋が君を待っているぞ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="突然" mdxType="Ex">Tout d'un coup</Ex>,{" "}
  <Ex m="あいまいな主語。文脈により「私は」「私たちは」「みんな」など様々な意味になる。" mdxType="Ex">
    on
  </Ex>{" "}
  <Ex m="作る、する" o="faire" mdxType="Ex">
    fait
  </Ex>{" "}
  <Ex m="沈黙" mdxType="Ex">silence</Ex>, on fait silence...
    </p>
    <Translation mdxType="Translation">突然みなが静まり返る…</Translation>
    <p>
  Ah! <Ex m="何が" mdxType="Ex">que</Ex>{" "}
  <Ex m="起こる（il se passeの倒置）" o="se passer" mdxType="Ex">
    se passe-t-il
  </Ex>{" "}
  ?
    </p>
    <Translation mdxType="Translation">ああ！ いったい何が起こったのか？</Translation>
    <p>
  <Ex m="もはや〜ない" mdxType="Ex">Plus</Ex> de <Ex m="叫び声" mdxType="Ex">cris</Ex>, c'est{" "}
  <Ex m="瞬間" mdxType="Ex">l'instant</Ex> ! Plus de cris, c'est l'instant !
    </p>
    <Translation mdxType="Translation">叫び声一つない、その瞬間！</Translation>
    <p>
  <Ex m="雄牛" mdxType="Ex">Le taureau</Ex>{" "}
  <Ex m="突進する" o="s'élancer" mdxType="Ex">
    s'élance
  </Ex>
    </p>
    <Translation mdxType="Translation">雄牛が突進する</Translation>
    <p>
  <Ex m="ジェロンディフのen。後ろに現在分詞を伴い、「〜しながら」「〜することによって」などの意味になる" mdxType="Ex">
    En
  </Ex>{" "}
  <Ex m="飛び跳ねる" o="bondir" mdxType="Ex">
    bondissant
  </Ex>{" "}
  <Ex m="外に" mdxType="Ex">hors</Ex> <Ex m="= de + le。hors de 〜で「〜の外に」" mdxType="Ex">du</Ex>{" "}
  <Ex m="（スペイン語）闘牛場の牛の控え場。du = de + le" mdxType="Ex">Toril</Ex> !
    </p>
    <Translation mdxType="Translation">囲いから飛び出して！</Translation>
    <p>
  <Ex m="= le taureau （男性名詞単数を受ける主語代名詞）" mdxType="Ex">Il</Ex>{" "}
  <Ex m="突進する" o="s'élancer" mdxType="Ex">
    s'élance
  </Ex>{" "}
  ! il{" "}
  <Ex m="入る" o="entrer" mdxType="Ex">
    entre
  </Ex>
  , il <Ex m="打つ、衝突する" o="frapper" mdxType="Ex">
    frappe
  </Ex> ! <Ex m="馬" mdxType="Ex">un cheval</Ex> <Ex m="転がる" o="rouler" mdxType="Ex">
    roule
  </Ex>,
    </p>
    <Translation mdxType="Translation">突進！ 乱入！ 突きかかる！ 馬が倒れる</Translation>
    <Ex m="引きずる、巻き添えにする（現在分詞）" o="entraîner" mdxType="Ex">
  Entraînant
    </Ex>{" "}
    <Ex m="ピカドール。闘牛士の役割のひとつ" mdxType="Ex">un Picador</Ex>,
    <Translation mdxType="Translation">ピカドールを引きずって</Translation>
    <p>{`Ah ! bravo ! `}<Ex m="牛（スペイン語。フランス語ではtaureau）" mdxType="Ex">{`Toro`}</Ex>{` ! `}<Ex m="わめく" o="hurler" mdxType="Ex">{`hurle`}</Ex>{` `}<Ex m="群衆" mdxType="Ex">{`la foule`}</Ex></p>
    <Translation mdxType="Translation">ああ！ ブラボー！ 牛よ！ 群衆がわめく</Translation>
    <p>
  <Ex m="雄牛" mdxType="Ex">Le taureau</Ex>{" "}
  <Ex m="行く" o="aller" mdxType="Ex">
    va
  </Ex>
  , <Ex m="= le taureau" mdxType="Ex">il</Ex> <Ex m="来る" o="venir" mdxType="Ex">
    vient
  </Ex>, il vient et <Ex m="打つ、衝突する" o="frapper" mdxType="Ex">
    frappe
  </Ex> <Ex m="もう一度（現代フランス語ではencoreと書く）" mdxType="Ex">encor</Ex> !
    </p>
    <Translation mdxType="Translation">
  牛は行き、またやってくる、やってきて、また突きかかる！
    </Translation>
    <p>
  {" "}
  <Ex m="ジェロンディフのen。後ろに現在分詞を伴い、「〜しながら」「〜することによって」などの意味になる" mdxType="Ex">
    En
  </Ex> <Ex m="揺さぶる（現在分詞）" o="secouer" mdxType="Ex">
    secouant
  </Ex> <Ex m="英語のhis/herにあたる、所有を表す形容詞。その複数形。ここでは牛が複数の槍を持っている（背中に刺さっている）ことを示す。" mdxType="Ex">
    ses
  </Ex> <Ex m="バンデリリャ（闘牛で使う飾りのついた槍）" mdxType="Ex">banderilles</Ex>,
    </p>
    <Translation mdxType="Translation">刺さった槍を揺さぶりながら</Translation>
    <p>
  <Ex m="〜でいっぱいの" mdxType="Ex">Plein de</Ex> <Ex m="激怒" mdxType="Ex">fureur</Ex>, il{" "}
  <Ex m="走る" o="courir" mdxType="Ex">
    court
  </Ex>{" "}
  ! <Ex m="サーカス、競技場（ここでは闘牛場）" mdxType="Ex">le cirque</Ex>{" "}
  <Ex m="〜である（英語のbe動詞）" o="être" mdxType="Ex">
    est
  </Ex>{" "}
  <Ex m="〜でいっぱいの" mdxType="Ex">plein de</Ex> <Ex m="血" mdxType="Ex">sang</Ex> !
    </p>
    <Translation mdxType="Translation">怒り狂って駆け回る！ 闘牛場は血の海だ！</Translation>
    <p>
  <Ex m="あいまいな主語。文脈により「私は」「私たちは」「みんな」など様々な意味になる。" mdxType="Ex">
    On
  </Ex>{" "}
  <Ex m="逃げ出す" o="se sauver" mdxType="Ex">
    se sauve
  </Ex>
  , on <Ex m="越える" o="franchir" mdxType="Ex">
    franchit
  </Ex> <Ex m="柵" mdxType="Ex">les grilles</Ex> !
    </p>
    <Translation mdxType="Translation">みなが逃げ出す、柵を越えて！</Translation>
    <p>
  C'est <Ex m="君の" mdxType="Ex">ton</Ex> <Ex m="順番" mdxType="Ex">tour</Ex> <Ex m="今" mdxType="Ex">maintenant</Ex>{" "}
  !
    </p>
    <Translation mdxType="Translation">今こそお前の出番だ！</Translation>
    <p>
  <Ex m="さあ（掛け声）" o="aller" mdxType="Ex">
    Allons
  </Ex>{" "}
  ! <Ex m="構えろ" mdxType="Ex">en garde</Ex> ! allons ! allons ! ah !
    </p>
    <Translation mdxType="Translation">さあ！ 構えろ！ さあ！ さあ！</Translation>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="闘牛士" mdxType="Ex">Toréador</Ex>, en garde ! Toréador ! Toréador !
    </p>
    <Translation mdxType="Translation">
  トレアドール、構えはいいか！ トレアドール！ トレアドール！
    </Translation>
    <p>
  <Ex m="そして（英語のand）" mdxType="Ex">Et</Ex>{" "}
  <Ex m="考える、想像する" o="songer" mdxType="Ex">
    songe
  </Ex>{" "}
  <Ex m="よく" mdxType="Ex">bien</Ex>, <Ex m="はい（英語のyes、ここでは強調）" mdxType="Ex">oui</Ex>,
  songe{" "}
  <Ex m="戦いながら" o="combattre" mdxType="Ex">
    en combattant
  </Ex>
  ,
    </p>
    <Translation mdxType="Translation">そして忘れるな、そう、戦いながらも忘れるな</Translation>
    <p>
  <Ex m="〜であること（英語のthat）ここではsongerの目的語" o="que" mdxType="Ex">
    Qu'
  </Ex>
  <Ex m="目" mdxType="Ex">un œuil</Ex> <Ex m="黒い" mdxType="Ex">noir</Ex> <Ex m="君を" mdxType="Ex">te</Ex> <Ex m="見る" o="regarder" mdxType="Ex">
    regarde
  </Ex>
    </p>
    <Translation mdxType="Translation">黒い瞳が君を見つめていることを</Translation>
    <p>
  Et <Ex m="〜であること（Qu'un œuilのqu'と並列になっている）" mdxType="Ex">que</Ex>{" "}
  <Ex m="愛、恋" mdxType="Ex">l'amour</Ex>{" "}
  <Ex m="te (君を) + attend (待つ)" o="attendre" mdxType="Ex">
    t'attend
  </Ex>
  , Toréador,
    </p>
    <Translation mdxType="Translation">そして恋が君を待っていることを。トレアドール</Translation>
    <p>L'amour, l'amour t'attend !</p>
    <Translation mdxType="Translation">恋が、恋が君を待っているぞ！</Translation>
    <p>L'amour ! L'amour ! L'amour !</p>
    <Translation mdxType="Translation">恋！ 恋！ 恋！</Translation>
    <p>Toréador ! Toréador ! L'amour t'attend !</p>
    <Translation mdxType="Translation">トレアドール！ トレアドール！ 恋が君を待っているぞ！</Translation>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b8bb6213d7ebb13f2fdad586f2f200d6/8698d/carmen-toreador.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "429%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/b8bb6213d7ebb13f2fdad586f2f200d6/5a190/carmen-toreador.png",
            "srcSet": ["/static/b8bb6213d7ebb13f2fdad586f2f200d6/772e8/carmen-toreador.png 200w", "/static/b8bb6213d7ebb13f2fdad586f2f200d6/e17e5/carmen-toreador.png 400w", "/static/b8bb6213d7ebb13f2fdad586f2f200d6/5a190/carmen-toreador.png 800w", "/static/b8bb6213d7ebb13f2fdad586f2f200d6/c1b63/carmen-toreador.png 1200w", "/static/b8bb6213d7ebb13f2fdad586f2f200d6/8698d/carmen-toreador.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      